import route from './route';
import { LazyloadWrapper } from '../../Components/Common';

const MemberManagement = LazyloadWrapper(import('./MemberManagement'));

export default {
  RenderProp: MemberManagement,
  mainRoute: route,
};
